import { formatDecimalToPrice } from "../../utils/formatDecimalToPrice";

export function decorateItemBox(data, typeName, timelineEntry) {
    const itemContainer = $(`.timeline_entry.${typeName}#${timelineEntry.id}`).find(".item");
    const spinner = itemContainer.find(".js-spinner");
    // If item not found
    if (!data.item) {
        spinner.hide();
        return;
    }
    // Handle image
    const imgSrc = data.item.filename
        ? `/userdata/mysydeshop/images/tumb_3/${data.item.filename}`
        : `/userdata/mysydeshop/images/tumb_4/noimage.jpg`;
    itemContainer.find(".js-item-image").prepend(
        `<img src='${imgSrc}' alt='${data.item.description}' title='${data.item.description}' />`
    );
    // Fill descriptions
    const descriptionContainer = itemContainer.find(".description");
    descriptionContainer.find(".item_description").text(data.item.description);
    descriptionContainer.find(".item_long_description").html(data.item.long_description);
    const pointsBanner = itemContainer.find(".js-item-points");
    if (data.item.points_value) {
        pointsBanner.text(data.item.points_value);
    }else{
        pointsBanner.remove();
    }
    itemContainer.find(".js-item-price").text("+ "+formatDecimalToPrice(data.item.base_price));

    // Site & language codes
    const siteCodeFinal = data.site_and_language_code.site_code || siteCode;
    const langCodeFinal = data.site_and_language_code.language_code || mainLanguageCode;

    // Link
    const link = `/${siteCodeFinal}/${langCodeFinal}/shop/${data.item_link}/?card=${data.item.id}`;
    itemContainer.find(".js-item-link").attr("href", link).text("Zum Artikel");
    // Final UI updates
    spinner.hide();
}
